// extracted by css-extract-rspack-plugin
export default {"badge":"StackBadge-module__badge__FJFUi","link":"StackBadge-module__link__sPa3D"};